module.exports = __webpack_public_path__ + "img/HeroTypesQuiz-Q3.c1d6c5bb.png";